export default "__VITE_ASSET__DsvyNLQg__"